import { NavLink as Link } from "react-router-dom";
import styled from "styled-components";

export const Nav = styled.nav`
  background: #fff;
  display: block;
  display: flex;
  max-width: 91vw;
  min-width: 74vw;
  margin: 0 auto;
  justify-content: space-between;
`;

export const NavLink = styled(Link)`
  color: #515358;
  text-decoration: none;
  font-size: 18px;
  font-weight: 300;
  height: 100%;
  cursor: pointer;

  &:active-link {
    color: red;
  }
  &.hover {
    border-bottom: none;
  }
  text-transform: capitalize;
`;

export const NavMenu = styled.div(({ show }) => ({
  display: show ? "flex" : "none",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "60px",
  marginTop: "6px",
  marginBottom: "10px",
}));

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

export const NavBtnLink = styled(Link)`
  border-radius: 4px;
  background: #808080;
  padding: 10px 22px;
  color: #000000;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  /* Second Nav */
  margin-left: 24px;
  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #808080;
  }
`;
